import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { SITE_URL } from './metaConfig';

/**
 * Ставит Title и Description на страницу.
 * Использование: <Seo title="..." description="..." /> в начале компонента страницы.
 * Картинка (image) нужна только для красивого превью ссылки в мессенджерах.
 */
// Один адрес-оригинал у страницы: нижний регистр, без хвостовой косой черты
// и без /index.html - иначе одна страница объявляет себя оригиналом
// сразу по нескольким адресам.
export function canonicalUrl(pathname) {
  let clean = (pathname || '/').toLowerCase();
  if (clean.endsWith('/index.html')) {
    clean = clean.slice(0, -'index.html'.length);
  }
  if (clean.length > 1) {
    clean = `/${clean.replace(/^\/+|\/+$/g, '')}`;
  }
  // /cards/0051 и /cards/51 - одна страница, оригинал должен быть один
  clean = clean.replace(/^(\/(?:cards|articles))\/0+(\d+)$/, '$1/$2');
  return `${SITE_URL.replace(/\/$/, '')}${clean}`;
}

export default function Seo({ title, description, image, noindex = false }) {
  const { pathname } = useLocation();
  const canonical = canonicalUrl(pathname);

  const tags = [];
  if (title) {
    tags.push(<title key="title">{title}</title>);
    tags.push(<meta key="og:title" property="og:title" content={title} />);
  }
  if (description) {
    tags.push(<meta key="desc" name="description" content={description} />);
    tags.push(
      <meta key="og:desc" property="og:description" content={description} />,
    );
  }
  tags.push(<link key="canonical" rel="canonical" href={canonical} />);
  tags.push(<meta key="og:type" property="og:type" content="website" />);
  tags.push(<meta key="og:url" property="og:url" content={canonical} />);
  if (image) {
    tags.push(<meta key="og:image" property="og:image" content={image} />);
  }
  if (noindex) {
    tags.push(<meta key="robots" name="robots" content="noindex, follow" />);
  }

  // defer={false} - применять теги сразу, а не в следующем кадре отрисовки:
  // в фоновой вкладке кадра можно ждать вечно, и заголовок остаётся старым.
  return <Helmet defer={false}>{tags}</Helmet>;
}
